import React from 'react'
import "./UaeMofa.css"

const UaeMofaHead = () => {
  return (
    <div className='uaeMofaHeadContainer'>
      <h2>MOFA</h2>
      <div className='uaeMUnderline'></div>
    </div>
  )
}

export default UaeMofaHead
